import React from 'react';
import { ArrowDownToLine, ArrowUpFromLine } from 'lucide-react';

/**
 * Deposit/Withdraw tab toggle. Pure, controlled.
 */
export default function VaultTabs({ mode, onChange }) {
  return (
    <div className="inline-flex p-1 rounded-2xl bg-black/30 border border-white/5" role="tablist">
      <TabButton
        active={mode === 'deposit'}
        onClick={() => onChange('deposit')}
        icon={<ArrowDownToLine size={15} strokeWidth={1.8} />}
        label="Deposit"
        testId="deposit-tab"
      />
      <TabButton
        active={mode === 'withdraw'}
        onClick={() => onChange('withdraw')}
        icon={<ArrowUpFromLine size={15} strokeWidth={1.8} />}
        label="Withdraw"
        testId="withdraw-tab"
      />
    </div>
  );
}

function TabButton({ active, onClick, icon, label, testId }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={`inline-flex items-center gap-2 px-5 h-10 rounded-xl text-sm font-semibold transition-all ${
        active ? 'bg-palm-lime text-palm-surface shadow-lime' : 'text-white/70 hover:text-white'
      }`}
      data-testid={testId}
    >
      {icon}
      {label}
    </button>
  );
}
